import styled from 'styled-components';

export const AgreementTransferStatusWrapper = styled.div`
  h1 {
    font-weight: 700;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-top: 32px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    flex-direction: row;
    gap: 48px;
  }
`;

export const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
`;

export const Sidebar = styled.aside`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;

  h2 {
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 8px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.small}) and (max-width: calc(${({
      theme,
    }) => theme.breakpoints.medium} - 1px)) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 32px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    display: flex;
    flex-direction: column;
    width: 344px;
    flex-shrink: 0;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 64px;
`;

export const TransferCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const LearnMoreLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.buttonButtonPrimarySecondary2100};
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;

  svg {
    width: 14px;
    height: 14px;
  }

  &:hover {
    text-decoration: underline;
  }
`;

export const SidebarCardBody = styled.p`
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.textSecondaryGrey90};
  margin: 0;
`;
